import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Navigate, useLocation } from "react-router-dom";
import { AuthState, useAuth } from './auth';

interface LocationState {
  from: {
    pathname: string;
  };
};

const RouteSignIn = () => {
  let location = useLocation();
  let auth = useAuth();

  let { from } = location.state as LocationState || { from: { pathname: "/" } };

  switch (auth.state) {
    case AuthState.SignedIn:
      return (<Navigate to={{ pathname: from.pathname }} />);
    case AuthState.SignedOut:
      return (
        <Row>
          <Col>
            <p>You must log in to view the page at {from.pathname}</p>
          </Col>
        </Row>
      );
    case AuthState.Idle:
      // Auth hasn't been triggered yet, likely from loading /login directly.
      return (<Navigate to={{ pathname: from.pathname }} />);
    default:
      // Loading
      return (<></>);
  }
}

export default RouteSignIn;